import React from 'react';
import Modal from 'react-modal';
import { useUser } from '../../api/users'; // Adjust the import path as needed
import { useReservationByUser } from '../../api/reservations'; // Adjust the import path as needed
import { useAuth } from '../../api/AuthProvider';
import { FaTimes, FaUser, FaEnvelope, FaPhone } from 'react-icons/fa';

const UserDetailsModal = ({ userid, isOpen, onClose }) => {
  const { data: user, isLoading, error } = useUser(userid);
  const { data: reservations, isLoading: isLoadingReservations, error: errorReservations } =
    useReservationByUser(userid);

  if (!userid || error || errorReservations) {
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: 'clamp(320px, 90vw, 480px)',
            maxWidth: '100%',
            background: '#ffffff',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
            padding: 'clamp(1.5rem, 3vw, 2rem)',
            fontFamily: "'Inter', 'Arial', sans-serif",
            animation: 'modal-slideIn 0.3s ease-out',
            textAlign: 'center',
          },
        }}
      >
        <style>
          {`
            @keyframes modal-slideIn {
              from {
                transform: translate(-50%, calc(-50% - 20px));
                opacity: 0;
              }
              to {
                transform: translate(-50%, -50%);
                opacity: 1;
              }
            }
          `}
        </style>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <p style={{ color: '#ef4444', fontSize: 'clamp(1rem, 1.5vw, 1.125rem)', fontWeight: 500 }}>
            Error loading user data
          </p>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 'clamp(1.25rem, 2vw, 1.5rem)',
              color: '#6b7280',
              transition: 'color 0.2s ease',
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = '#374151')}
            onMouseOut={(e) => (e.currentTarget.style.color = '#6b7280')}
          >
            <FaTimes />
          </button>
        </div>
      </Modal>
    );
  }

  if (isLoading || isLoadingReservations) {
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: 'clamp(320px, 90vw, 480px)',
            maxWidth: '100%',
            background: '#ffffff',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
            padding: 'clamp(1.5rem, 3vw, 2rem)',
            fontFamily: "'Inter', 'Arial', sans-serif",
            animation: 'modal-slideIn 0.3s ease-out',
            textAlign: 'center',
          },
        }}
      >
        <style>
          {`
            @keyframes modal-slideIn {
              from {
                transform: translate(-50%, calc(-50% - 20px));
                opacity: 0;
              }
              to {
                transform: translate(-50%, -50%);
                opacity: 1;
              }
            }
          `}
        </style>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <p style={{ fontSize: 'clamp(1rem, 1.5vw, 1.125rem)', fontWeight: 500, color: '#374151' }}>
            Loading...
          </p>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 'clamp(1.25rem, 2vw, 1.5rem)',
              color: '#6b7280',
              transition: 'color 0.2s ease',
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = '#374151')}
            onMouseOut={(e) => (e.currentTarget.style.color = '#6b7280')}
          >
            <FaTimes />
          </button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: 'clamp(320px, 90vw, 480px)',
          maxWidth: '100%',
          background: '#ffffff',
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
          padding: 'clamp(1.5rem, 3vw, 2rem)',
          fontFamily: "'Inter', 'Arial', sans-serif",
          animation: 'modal-slideIn 0.3s ease-out',
          textAlign: 'center',
        },
      }}
    >
      <style>
        {`
          @keyframes modal-slideIn {
            from {
              transform: translate(-50%, calc(-50% - 20px));
              opacity: 0;
            }
            to {
              transform: translate(-50%, -50%);
              opacity: 1;
            }
          }
        `}
      </style>
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '12px',
          right: '12px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: 'clamp(1.25rem, 2vw, 1.5rem)',
          color: '#6b7280',
          transition: 'color 0.2s ease',
        }}
        onMouseOver={(e) => (e.currentTarget.style.color = '#374151')}
        onMouseOut={(e) => (e.currentTarget.style.color = '#6b7280')}
      >
        <FaTimes />
      </button>

      {user.profile_picture ? (
        <img
          src={user.profile_picture}
          alt="Profile"
          style={{
            width: 'clamp(120px, 20vw, 160px)',
            height: 'clamp(120px, 20vw, 160px)',
            borderRadius: '50%',
            objectFit: 'cover',
            margin: '0 auto 16px',
            border: '1px solid #e5e7eb',
          }}
        />
      ) : (
        <div
          style={{
            backgroundColor: '#3fb488',
            width: 'clamp(100px, 18vw, 140px)',
            height: 'clamp(100px, 18vw, 140px)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px',
            border: '1px solid #e5e7eb',
          }}
        >
          <FaUser size={60} color="#ffffff" />
        </div>
      )}

      <h2
        style={{
          color: '#3fb488',
          fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
          fontWeight: 500,
          marginBottom: '16px',
        }}
      >
        {user.full_name}
      </h2>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '12px',
          width: '100%',
        }}
      >
        <FaEnvelope size={20} color="#3fb488" />
        <a
          href={`mailto:${user.email}`}
          style={{
            fontSize: 'clamp(0.875rem, 1.2vw, 1rem)',
            fontWeight: 500,
            marginLeft: '8px',
            color: '#374151',
            textDecoration: 'none',
            transition: 'color 0.2s ease',
          }}
          onMouseOver={(e) => (e.currentTarget.style.color = '#3fb488')}
          onMouseOut={(e) => (e.currentTarget.style.color = '#374151')}
        >
          {user.email}
        </a>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '12px',
          width: '100%',
        }}
      >
        <FaPhone size={20} color="#3fb488" />
        <a
          href={`tel:${user.phonenumber}`}
          style={{
            fontSize: 'clamp(0.875rem, 1.2vw, 1rem)',
            fontWeight: 500,
            marginLeft: '8px',
            color: '#374151',
            textDecoration: 'none',
            transition: 'color 0.2s ease',
          }}
          onMouseOver={(e) => (e.currentTarget.style.color = '#3fb488')}
          onMouseOut={(e) => (e.currentTarget.style.color = '#374151')}
        >
          {user.phonenumber}
        </a>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <span
          style={{
            fontSize: 'clamp(0.875rem, 1.2vw, 1rem)',
            fontWeight: 500,
            color: '#374151',
          }}
        >
          Number of Reservations:
        </span>
        <div
          style={{
            backgroundColor: '#3fb488',
            width: 'clamp(24px, 5vw, 32px)',
            height: 'clamp(24px, 5vw, 32px)',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '8px',
          }}
        >
          <span
            style={{
              color: '#ffffff',
              fontSize: 'clamp(0.875rem, 1.2vw, 1rem)',
              fontWeight: 500,
            }}
          >
            {reservations?.length > 0 ? reservations.length : '1'}
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default UserDetailsModal;